$(function () {
    $(".accordionjs").each(function () {
        $(this).accordionjs({
            closeAble: true
        });
    });
    $('.variable-items-wrapper.image-variable-wrapper li').each(function () {
        $(this).append("<span class=\"image-variable-wrapper--title\">".concat(this.title, "</span>"));
    });
    $("#woosb-product-montage").prependTo(".woosb-products");
});
